import { Table } from 'antd'
import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 20px;
  background: white;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
`

export const Title = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
`

export const Explainer = styled.p`
  margin: 0 0 20px;
  max-width: 640px;
  color: #666;
  font-size: 13px;
`

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`

export const StatTile = styled.div`
  min-width: 140px;
  padding: 12px 16px;
  border: 1px solid #eee;
  border-radius: 8px;
`

export const StatLabel = styled.div`
  font-size: 12px;
  color: #888;
`

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 600;
`

export const SectionTitle = styled.h2`
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
`

export const SectionNote = styled.p`
  margin: 0 0 12px;
  color: #888;
  font-size: 12px;
`

export const StyledTable = Table
